import { render } from "./DeliveryPickup.vue?vue&type=template&id=03c87626&scoped=true"
import script from "./DeliveryPickup.vue?vue&type=script&lang=js"
export * from "./DeliveryPickup.vue?vue&type=script&lang=js"

import "./DeliveryPickup.vue?vue&type=style&index=0&id=03c87626&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c87626"]])

export default __exports__